export default "__VITE_ASSET__6ea0d717__"